import { Box, Typography } from '@mui/material';
import EventCard from '../../components/EventCard/EventCard';
import { ModuleCardProps } from '../types';
import { getAdvisoryText, getNormalizedIcon } from '../utils';

const IncidentDisplayCard: React.FC<ModuleCardProps> = ({ icon, module }) => {
  const normalizedIcon = getNormalizedIcon(icon);
  const { advisoryText } = normalizedIcon || {};
  const locationless = normalizedIcon.locationless;

  if (locationless) {
    return null;
  } else {
    return (
      <Box sx={{ position: 'relative' }}>
        <EventCard icon={icon} module={module}>
          <Typography
            variant="body2"
            gutterBottom
            sx={{
              paddingBottom: 1,
              wordBreak: 'break-word',
              minWidth: { xs: '100px', md: 'fit-content' },
            }}
          >
            {getAdvisoryText(advisoryText) || 'No advisory text provided'}
          </Typography>
        </EventCard>
      </Box>
    );
  }
};

export default IncidentDisplayCard;
